// Preserve identifiers, payment query values and anchors through old bookmarks.
export function portalRedirect(name) {
    return to => ({
        name,
        params: {...to.params, lang: to.params.lang || 'fa'},
        query: to.query,
        hash: to.hash,
    })
}
